module.exports = __webpack_public_path__ + "static/5-cc3dfa564cfe89ba36e49a16416751a7.jpg";